import { prop } from "fw";

export class LazyValue {
  @prop(null) public value!: Date|number|string|boolean|object;
  @prop("div") public rootType!: string;
}
